export default __webpack_public_path__ + "static/media/วันเกิดคืนยอดเทิร์น2เท่า.385c24de.png";